var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DateTimePicker',{ref:"datepicker",staticClass:"w-full",attrs:{"value":this.item.response,"enableDate":_vm.item.params.date,"enableTime":_vm.item.params.time},on:{"change":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }